import React, { useEffect, useState } from 'react';
import Navbar from '../components/site/Navbar';
import FooterCTA from '../components/site/FooterCTA';
import Footer from '../components/site/Footer';
import LogoWatermark from '../components/site/LogoWatermark';

const LegalPage = ({ doc }) => {
  const [active, setActive] = useState(doc.sections[0].id);

  useEffect(() => {
    const handler = () => {
      // Find the section closest to top of viewport
      let current = doc.sections[0].id;
      for (const s of doc.sections) {
        const el = document.getElementById(s.id);
        if (!el) continue;
        const top = el.getBoundingClientRect().top;
        if (top - 140 <= 0) current = s.id;
      }
      setActive(current);
    };
    window.addEventListener('scroll', handler, { passive: true });
    handler();
    return () => window.removeEventListener('scroll', handler);
  }, [doc.sections]);

  const onJump = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 110;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <main className="bg-white text-[#12367F]">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-28 md:pt-36 pb-20 md:pb-28 overflow-hidden" style={{ background: '#12367F', color: '#FFFFFF' }}>
        <div
          aria-hidden
          className="absolute -right-40 top-1/4 w-[55vw] max-w-[800px] aspect-square pointer-events-none opacity-[0.07] rounded-[45%]"
          style={{ background: '#2EF5FF' }}
        />
        <LogoWatermark size={460} opacity={0.07} position="left" />
        <div className="container-x px-6 relative">
          <h1
            className="font-display uppercase text-balance"
            style={{ fontSize: 'clamp(2.75rem, 8vw, 8.5rem)', lineHeight: 0.9 }}
          >
            <span className="text-white">{doc.brand}</span>
            <br />
            <span className="inline-block px-3 py-1 rounded-md mt-3" style={{ background: '#2EF5FF', color: '#12367F' }}>
              {doc.title}
            </span>
          </h1>
          {doc.updated && (
            <p className="mt-8 text-white/70 text-sm uppercase tracking-[0.25em]">
              Last updated: {doc.updated}
            </p>
          )}
        </div>
      </section>

      {/* Body with sticky TOC */}
      <section className="py-16 md:py-24" style={{ background: '#FFFFFF' }}>
        <div className="container-x px-6 grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Sidebar TOC */}
          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-28 rounded-3xl bg-[#F4F6F1] border border-[#12367F]/10 p-6 md:p-8">
              <p className="text-xs uppercase tracking-[0.25em] text-[#12367F]/60 font-medium mb-6">
                In this article
              </p>
              <nav className="space-y-1">
                {doc.sections.map((s, i) => {
                  const isActive = active === s.id;
                  return (
                    <a
                      key={s.id}
                      href={`#${s.id}`}
                      onClick={(e) => onJump(e, s.id)}
                      className={`block px-3 py-2.5 rounded-lg text-sm md:text-[15px] transition-colors ${
                        isActive
                          ? 'bg-[#2EF5FF] text-[#12367F] font-semibold'
                          : 'text-[#12367F]/85 hover:bg-[#12367F]/5'
                      }`}
                    >
                      {i + 1}. {s.title}
                    </a>
                  );
                })}
              </nav>
            </div>
          </aside>

          {/* Content */}
          <article className="lg:col-span-8 space-y-14 md:space-y-16">
            {doc.sections.map((s, i) => (
              <section key={s.id} id={s.id} className="scroll-mt-32">
                <h2
                  className="font-display uppercase text-[#12367F]"
                  style={{ fontSize: 'clamp(1.75rem, 3.5vw, 3rem)', lineHeight: 1 }}
                >
                  {i + 1}. {s.title}
                </h2>
                <div className="mt-6 space-y-5 text-[#12367F]/85 text-base md:text-lg leading-relaxed">
                  {s.body.map((p, j) => (
                    <p key={j}>{p}</p>
                  ))}
                </div>
              </section>
            ))}
          </article>
        </div>
      </section>

      <FooterCTA />
      <Footer />
    </main>
  );
};

export default LegalPage;
